/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-mapping-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleCreate = `${prefix}.modalTitleCreate`;
export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const numberOfMatchesLabel = `${prefix}.numberOfMatchesLabel`;
export const classifyAsLabel = `${prefix}.classifyAsLabel`;
export const addButtonLabel = `${prefix}.addButtonLabel`;
export const botMappingRulesLabel = `${prefix}.botMappingRulesLabel`;

export const ENGLISH = {
    [modalTitleCreate]: 'Create Bot Mapping',
    [modalTitleEdit]: 'Edit Bot Mapping',
    [numberOfMatchesLabel]: 'Number of Matches',
    [classifyAsLabel]: 'Classify as: ',
    [addButtonLabel]: 'Add',
    [botMappingRulesLabel]: 'Bot Mapping Rules ({0})',
};
